module.exports = __webpack_public_path__ + "static/media/ApproveWorkflowHint.4e9ccba9.svg";